
import React, { useEffect, useState } from 'react';
import { Clock, Truck } from 'lucide-react';
import { base_url } from 'Backend/api';
import OrderModal from './OrderModal';
import { motion } from 'framer-motion';
import Icon from "../../../components/AppIcon";

const DeliveryTrackingSection = () => {
  const [order, setOrder] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentOrder = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${base_url}/api/orders/current`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.status && data.data.orders.length > 0) {
          setOrder(data.data.orders[0]); 
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchCurrentOrder();
  }, []);

  if (loading || !order) return null;

  const storeNames = order.stores?.map((store) => store.name).join(" - ");

  return (
    <>
      {/* Full Section for Mobile */}
      <div className="px-2 py-1 font-[cairo] md:hidden">
        <div 
          className="bg-white rounded-[6px]  overflow-hidden cursor-pointer shadow-sm transition-shadow"
          onClick={() => setOpenModal(true)}
        >
          {/* Header Bar */}
          <div className="bg-[#FF4500] px-4 py-1 flex items-center gap-1">
            <h2 className="font-[cairo] text-white font-medium flex-1 text-left text-[10px] sm:text-md md:text-base">
              اضغط لعرض حالة الطلب
            </h2>
            <Icon name="ChevronLeft" size={10} color="white" />
          </div>

          {/* Content Area */}
          <div dir="ltr" className="bg-[#ffffff] px-4 py-1 flex items-center gap-2">
            <div className="w-20 h-10">
              <img src="/assets/images/trackk.png" alt="truck" className="w-full h-12 object-cover" />
            </div>
            <div className="flex-1 text-right">
              <h3 className="font-[cairo] text-gray-800 font-medium mb-1 leading-tight text-[10px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
                {storeNames}
              </h3>
              <div className="flex items-center justify-end gap-1">
              <span className="text-green-600 font-semibold text-[10px] sm:text-[8px] md:text-[10px] lg:text-[14px]">
                  {order.estimated_delivery_message}
                </span>
                <Clock className="w-3 h-3 sm:w-5 sm:h-5 md:w-6 md:h-6 text-green-600" />
                
              </div>
            </div>
          </div>

          
        </div>
      </div>

       {/* Floating Icon for Tablet/Desktop with Animation */}
    
<motion.div
  className="hidden md:flex fixed bottom-6 right-6 z-50 cursor-pointer items-center gap-2"
  onClick={() => setOpenModal(true)}
  animate={{ y: [0, -8, 0] }}
  transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
>
  <div className="flex items-center gap-3 bg-primary p-4 rounded-2xl shadow-lg">
    <Truck className="w-6 h-6 text-white" />
    <span className="text-white font-bold text-sm whitespace-nowrap font-[cairo]">
      انقر لعرض تفاصيل الطلب الحالي
    </span>
  </div>
</motion.div>

      {/* Modal */}
      {openModal && (
        <OrderModal order={order} onClose={() => setOpenModal(false)} onRefresh={() => window.location.reload()}/>
      )}
    </>
  );
};

export default DeliveryTrackingSection;